/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { mapModifiers } from 'libs/component';
import { Heading } from 'components/atoms/heading';
import Default from 'components/templates/default';
import { Section } from 'components/molecules/section';
import { OptionList } from 'components/molecules/option-list';
import { VENUE_SERVICE_LIST,BRAND_ADVERTISIONG_LIST } from 'libs/constants';
import { Waypoint } from 'react-waypoint';
import { useTranslation } from 'react-i18next';
import { VENUN_OPTION_LIST } from 'libs/constants';
import { useEffect } from 'react';

export interface MediaProps {
  currentTab?: number;
  onOptionSelected?: (tab: number) => void;
  onNewsClick?: (slug: string) => void;
}

export const VenueService: React.FC<MediaProps> = ({ currentTab: defaultCurrentTab = 0,onOptionSelected}) => {
  const { i18n } = useTranslation();
  const [currentTab, setCurrentTab] = useState<number>(defaultCurrentTab);
  // const [currentTab, setCurrentTab] = useState<number>(defaultCurrentTab);
  
  const optionList = useMemo(() => {
    return VENUN_OPTION_LIST;
  }, []);
  useEffect(() => {
    setCurrentTab(defaultCurrentTab);
  }, [setCurrentTab, defaultCurrentTab, currentTab]);

  const handleOptionSelected = useCallback(
    (index: number) => {
      setCurrentTab(index);
      if (onOptionSelected) {
        onOptionSelected(index);
      }
    },
    [setCurrentTab, onOptionSelected]
  );
  
  const optionItemList = optionList.map(x => (x.label as any)[i18n.language]);
  
  const [ ,setCurrentTopicIndex] = useState(0);
  const policyRef = useRef(null);

  const VenueServiceList = useMemo(() => {
    return VENUE_SERVICE_LIST.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);
  const BrandVenueServiceList = useMemo(() => {
    return BRAND_ADVERTISIONG_LIST.filter(x => (x.title as any)[i18n.language || 'en'] !== '');
  }, [i18n.language]);

  // const topics = useMemo(() => {
  //   return VenueServiceList
  //     .filter(x => !x.default && (x.title as any)[i18n.language || 'en'] !== '')
  //     .map(x => (x.title as any)[i18n.language || 'en']);
  // }, [i18n.language, VenueServiceList]);

  // const handleTopicClick = useCallback((index: number) => {
  //   const itemIndex = index + 1;
  //   setCurrentTopicIndex(itemIndex);
  //   // scroll to target
  //   const policyHolderEl = policyRef.current as any;
  //   if (policyHolderEl) {
  //     const menuEl = menuRef.current as any;
  //     const elList = policyHolderEl.querySelectorAll('.t-privacy-policy__info-detail');
  //     if (elList && typeof elList[itemIndex] !== 'undefined' && menuEl) {
  //       const el = elList[itemIndex] as HTMLDivElement;
  //       const bodyRect = document.body.getBoundingClientRect();
  //       const rect = el.getBoundingClientRect();
  //       const menuRect = menuEl.getBoundingClientRect();

  //       if (rect && menuRect) {
  //         const offset = window.innerWidth <= 640 ? menuRect.height / 4 + 120 : 80 * 2;
  //         const topPos = rect.top - bodyRect.top - offset;
  //         window.scrollTo({ top: topPos, left: 0, behavior: 'smooth' });
  //       }
  //     }
  //   }
  // }, []);

  const handleSectionEnter = useCallback((index: number) => {
    setCurrentTopicIndex(index);
  }, []);

  // const handleSelectChanged = useCallback(
  //   (value: string) => {
  //     const index = Number(value);
  //     handleTopicClick(index);
  //   },
  //   [handleTopicClick]
  // );

  return (
    <div className={mapModifiers('t-privacy-policy')}>
      <Default>
        <article className="t-privacy-policy__content">
          <Section className="t-privacy-policy__heading">
            <Heading>服务</Heading>
            <Section className="t-media__tabs">
              <OptionList
                currentIndex={currentTab}
                modifiers="horizontal"
                items={optionItemList}
                onSelected={handleOptionSelected}
              />
            </Section>
          </Section>

          
          {currentTab === 0 && (
            <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {VenueServiceList.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
          )}
          {currentTab === 1 && (
            <Section className="t-privacy-policy__detail">
            <div className="t-privacy-policy__info" ref={policyRef}>
              {BrandVenueServiceList.map((policy: any, index: number) => (
                <div key={index} className="t-privacy-policy__info-detail-holder">
                  <Waypoint onEnter={() => handleSectionEnter(index)} />
                  <div
                    className="t-privacy-policy__info-detail"
                    dangerouslySetInnerHTML={{ __html: (policy.content as any)[i18n.language || 'en'] }}
                  />
                </div>
              ))}
            </div>
          </Section>
          )}
        </article>
      </Default>
    </div>
  );
};
